import React, { useEffect } from 'react';
import './Marketing.css';

// Shared dialog for the Marketing pages' add/edit forms and delete
// confirmations. Submits on Enter (the body is a <form>), closes on Escape or a
// click on the backdrop.
export default function Modal({
    title,
    onClose,
    onSubmit,
    submitLabel = 'Save',
    submitVariant = 'primary',
    submitting = false,
    submitDisabled = false,
    // wide makes room for forms with several fields to a row.
    wide = false,
    error,
    children,
}) {
    useEffect(() => {
        const onKeyDown = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown);
    }, [onClose]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!submitting && !submitDisabled) onSubmit();
    };

    return (
        <div
            className="mkt-modal__scrim"
            // Only a click on the backdrop itself closes — not one that started
            // inside the dialog and drifted out.
            onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}
        >
            <div className={`mkt-modal${wide ? ' mkt-modal--wide' : ''}`} role="dialog" aria-modal="true" aria-label={title}>
                <div className="mkt-modal__header">
                    <h2 className="mkt-modal__title">{title}</h2>
                    <button type="button" className="mkt-modal__close" onClick={onClose} aria-label="Close">×</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="mkt-modal__body">
                        {error && <p className="mkt__error">{error}</p>}
                        {children}
                    </div>

                    <div className="mkt-modal__footer">
                        <button type="button" className="mkt__btn-secondary" onClick={onClose} disabled={submitting}>
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={submitVariant === 'danger' ? 'mkt__btn-danger' : 'blueButton'}
                            disabled={submitting || submitDisabled}
                        >
                            {submitting ? 'Saving…' : submitLabel}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
